import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import JourneyTableRow from './JourneyTableRow';

function PatientCategoryTableRow({ basePatientCategory, patientCategory }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <React.Fragment>
      <TableRow
        sx={{
          '& > *': { borderBottom: 'unset' },
        }}
      >
        <TableCell sx={{ width: '40px' }}>
          <IconButton onClick={() => setOpen(!open)} size="small">
            <FontAwesomeIcon
              icon={open ? 'fa-chevron-up' : 'fa-chevron-down'}
            />
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" sx={{ width: '100%' }}>
          {patientCategory.name}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={2}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="overline" gutterBottom>
                {t('components.patientCategoryMap.journey')}
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: '40px' }} />
                    <TableCell sx={{ width: '100%' }}>
                      {t('components.patientCategoryMap.path.start')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {patientCategory.journey.map((journey) => {
                    const baseJourney = basePatientCategory.journey.find(
                      (i) => i.start_unit === journey.start_unit,
                    );
                    return (
                      <JourneyTableRow
                        key={journey.start_unit}
                        baseJourney={baseJourney}
                        journey={journey}
                      />
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default PatientCategoryTableRow;
